import { Container, CompanyListWrapper } from './TopicListStyles';
import CompanyList from './companyList/CompanyList';
import EsgTopicTitle from '../../listItem/EsgTopicTitle/EsgTopicTitle';

interface TopicListProps {
  topic: any;
  rank: number;
}

const TopicList = ({ topic, rank }: TopicListProps) => {
  return (
    <Container>
      <EsgTopicTitle topic={topic} rank={rank} />

      <CompanyListWrapper>
        <CompanyList data={topic.company_list} />
      </CompanyListWrapper>
    </Container>
  );
};

export default TopicList;
